import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8dsbacu565: FaireBrandEntity = {
  token: "b_8dsbacu565",
  type: "brand",
  name: "Sunkissed Coconut",
  avatarUrl:
    "https://cdn.faire.com/fastly/6fe574491aac2503a78368d9dcb56b2b153328685957cd44942686b85761a8d2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6dda21e39306ef1c4f2684d288b68e387415e3f2c5b4bde6f59c807ef6a9454b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6fe574491aac2503a78368d9dcb56b2b153328685957cd44942686b85761a8d2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6dda21e39306ef1c4f2684d288b68e387415e3f2c5b4bde6f59c807ef6a9454b.png",
  location: "Alpharetta, GA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 167,
  isTopShop: true,
  isInsider: true,
  description:
    "Sunkissedcoconut is a clothing brand specializing in cozy hoodies, sweatshirts, lounge sets, pajamas, and t-shirts, crafted from the cutest colors of cottons and fabrics. Our diverse designs range from trendy graphics to intricate embroidery, complemented by some accessories, ensuring your customers stand out effortlessly.\n\nWe create fashion trends that encourage repeat purchases from your customers, solidifying our reputation as a brand that truly understands the value of exceptional craftsmanship and style. \n\nWe take great pride in our open sizing options of 6 units, allowing you to choose the sizes that best meet your customers' needs, ensuring a tailored fit for everyone. No $ minimum.\n\nWEBSITE IS SUNKISSEDCOCONUTWHOLESALE.COM\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.200Z",
    importedBy: "entity-db-cli",
  },
};
